import { SORT_DIRECTIONS } from "pages/home-page/components/study-table/study-table-columns/columns.consts";

export const getOppositeSortDirection = (currentSortDirection: string) =>
  currentSortDirection === SORT_DIRECTIONS.ASC
    ? SORT_DIRECTIONS.DESC
    : SORT_DIRECTIONS.ASC;
